export default {"src":"/_next/static/media/question-mark-gray.112d7997.svg","height":15,"width":14,"blurWidth":0,"blurHeight":0};